import { localeStore } from '~/mobx/localesStore';

export const getInputFieldErrorText = (value?: string, locale?: string, limit: number = 30): string | null => {
  if (!value?.trim()) return localeStore.t(`required_field_error_${locale || ''}`);
  if (value.length > limit) return localeStore.t(`max_length_validation`, { numberOfChars: limit });

  return null;
};
